<template>
	<img src="@/assets/cypher.png" alt="Cypher" />
</template>

<script>

export default {
	name: 'Cypher',
}
</script>